import { useContext } from 'react';
import { TextContext } from './Context';

const WritingPad = () => {
  const { setText } = useContext(TextContext);
  return (
    <div className="markdown-writing-pad-container">
      <textarea
        className="markdown-writing-pad"
        placeholder="Write some that markdown magic....sssssss"
        onChange={(event) => setText(event.target.value)}
      />
    </div>
  );
};

export default WritingPad;
